import React from "react";
import { alpha } from "@mui/material/styles";
import { Box, Container } from "@mui/material";

function ColoredBox({ number, Color }) {
  const BoxStyle = {
    border: `1px solid ${Color}`,
    fontWeight: "bold",
    color: Color,
    backgroundColor: alpha(Color, 0.1),
    padding: "4px 12px", // Add padding for spacing around the text
    borderRadius: 9,
    margin: "auto",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginTop: "5px",
    width: "fit-content", // Let the box expand to fit its content
  };

  return (
    <Container>
      <Box style={BoxStyle}>{number}</Box>
    </Container>
  );
}
export default ColoredBox;
